




















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { FileHelper as _file } from '@/helper/file.helper';
import { VAction } from '@/models/pagedlistmodel';
import { vehicleInventoryService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    pages() {
      return this.pagedDeals.totalPages;
    },
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
})

export default class HomenetPage extends Base {
  public homenetItems: any[] = [];
  public actions: VAction[] = [];
  public loading: boolean = false;
  public pagination = new PaginationModel('createdAT', true);
  public homeAttachmentLoader: boolean = false;

  public mounted() {
    this.getHomnetVehicleList();
    this.setActions();
  }
  
  public headers: VHeaders[] = [
    {
      text: "File Name",
      align: 'left',
      value: 'fileName',
      sortable: true,
    },
    {
      text: "Date and Time",
      align: 'left',
      value: 'createdAt',
      sortable: true,
      fieldType: 'template',
      template: (item) => {
        if(item.createdAt != null){
        var date = this.$moment(item.createdAt).utcOffset(0, false).format('MM/DD/YYYY');
        return `<span> ${date}</span>`;
        }else{
          return `<span> </span>`;
        }
      },
    },
    {
      text: this.$parent.$t('dealAttachment.gridHeaders.actions') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];

  public setActions() {
    this.actions = [{
      type: 'button',
      icon: 'fas fa-download',
      title: "Download",
      loading: false,
      action: (model: any, action) => {
        this.downloadFile(model.uri, action);
      },
    }
    ];
  }

  public async getHomnetVehicleList(): Promise<void> {
    try {
      this.loading = true;
      const response = await vehicleInventoryService.getHomnetVehicleList(
      );
      this.homenetItems = response.results;
      this.pagination.totalItems = response.total;
    } finally {
      this.loading = false;
    }
  }

  public async downloadFile(attachmentUri: string, action: any): Promise<void> {
    try {
      action.loading = true;
      this.homeAttachmentLoader = true;
      const attachment = await vehicleInventoryService.downloadHomenetAttachmentAsync(
        attachmentUri
      );
      const bytes = _file.base64ToArrayBuffer(attachment.fileContents);
      _file.downloadBytes(bytes, '', attachment.fileDownloadName);
    } catch (e) {
      this.showAlert(false, "File not found");
    } finally {
      action.loading = false;
      this.homeAttachmentLoader = false;
    }
  }

  public updatePaging(paging: PaginationModel): void {
    this.pagination = paging;
  }
}
